export default __webpack_public_path__ + "media/share/filled@2x-972bd466.png";